'use client';

import { useLocale } from 'next-intl';

import { useCurrency } from '@/features/shared/hooks/use-currency';

export function TrialFreePrice() {
  const currency = useCurrency();
  const locale = useLocale();
  const price = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(0);

  return <>{price}</>;
}
